import React from "react";

const TONES = {
  blue: "border-blue-200 hover:border-blue-400 text-blue-800",
  red: "border-rose-200 hover:border-rose-400 text-rose-700",
  amber: "border-amber-200 hover:border-amber-400 text-amber-800",
  green: "border-emerald-200 hover:border-emerald-400 text-emerald-800",
  slate: "border-slate-200 hover:border-slate-400 text-slate-800",
};

const Tile = ({ label, value, hint, tone, onClick, testid, idx }) => (
  <button type="button" data-testid={testid} onClick={onClick} disabled={!onClick} style={{ animationDelay: `${idx * 50}ms` }}
    className={`home-tile text-left bg-white border rounded-lg p-4 transition-[transform,border-color,box-shadow] ${onClick ? "hover:-translate-y-0.5 hover:shadow-md cursor-pointer" : "cursor-default"} ${TONES[tone]}`}>
    <div className="text-[11px] uppercase tracking-wider text-slate-500">{label}</div>
    <div className="text-3xl font-semibold tracking-tight mt-1 mono" data-testid={`${testid}-value`}>{value ?? "—"}</div>
    {hint && <div className="text-[11px] text-slate-500 mt-1">{hint}</div>}
  </button>
);

const days = (v) => (v == null ? "—" : `${v}d`);

export const OverviewTiles = ({ t, go }) => {
  const tiles = [
    { k: "open", label: "Open inquiries", value: t.open, hint: `avg age ${days(t.avg_open_age)}`, tone: "blue", to: { state: "open" } },
    { k: "pending", label: "Pending responses", value: t.pending_responses, hint: "contact is waiting on us", tone: "amber", to: { state: "open", pending: "1" } },
    { k: "overdue", label: "Overdue follow-ups", value: t.overdue_followups, hint: `${t.due_today} due today`, tone: "red", to: { followup: "overdue" } },
    { k: "conversion", label: "Conversion rate", value: t.conversion_rate == null ? "—" : `${t.conversion_rate}%`, hint: `${t.converted} converted · ${t.closed} closed`, tone: "green", to: { state: "converted" } },
    { k: "to-convert", label: "Avg days to convert", value: days(t.avg_days_to_convert), hint: "inquiry date → converted", tone: "slate" },
    { k: "to-close", label: "Avg days to close", value: days(t.avg_days_to_close), hint: "inquiry date → closed", tone: "slate", to: { state: "closed" } },
  ];
  return (
    <div className="grid grid-cols-2 md:grid-cols-3 xl:grid-cols-6 gap-3" data-testid="ov-tiles">
      {tiles.map((x, i) => <Tile key={x.k} idx={i} testid={`ov-tile-${x.k}`} {...x} onClick={x.to ? () => go(x.to) : null} />)}
    </div>
  );
};
